const genderOptions = Object.freeze([
  { text: "M.", value: 1, key: "m", excelKey: "M" },
  { text: "Mme.", value: 2, key: "mme", excelKey: "MME" },
  { text: "M. et Mme", value: 3, key: "m_et_mme", excelKey: "MEM" },
  { text: "M. ou Mme", value: 4, key: "m_ou_mme", excelKey: "MOM" },
]);

const contactTypeOptions = Object.freeze([
  { text: "Courrier postal", value: 1, key: "courrier_postal", excelKey: "CP" },
  { text: "Email", value: 2, key: "email", excelKey: "E" },
  // NOTE: DEV-5159: Comment for now LRE
  // { text: "LRE", value: 3, key: "lre", excelKey: "LRE" },
  { text: "Remise en main propre", value: 4, key: "remise_en_main_propre", excelKey: "REMP" },
]);

const allContactTypeOptions = Object.freeze([
  { text: "Courrier postal", value: 1, key: "courrier_postal", excelKey: "CP" },
  { text: "Email", value: 2, key: "email", excelKey: "E" },
  { text: "LRE", value: 3, key: "lre", excelKey: "LRE" },
  { text: "Remise en main propre", value: 4, key: "remise_en_main_propre", excelKey: "REMP" },
]);

const contactTypes = Object.freeze({
  courrier_postal: 1,
  email: 2,
  lre: 3,
  remise_en_main_propre: 4,
});

const entityTypes = Object.freeze({
  individual: 1,
  legal: 2,
});

const entityTypeOptions = Object.freeze([
  { text: "Particulier", value: 1, key: "individual", excelKey: "P" },
  { text: "Professionnel", value: 2, key: "legal", excelKey: "PRO" },
]);

export {
  genderOptions,
  contactTypeOptions,
  allContactTypeOptions,
  entityTypes,
  contactTypes,
  entityTypeOptions,
};
